import CityPageTemplate from "../city-template/CityPageTemplate";
import { jolietConfig } from "./data";

export default function JolietPage() {
  return <CityPageTemplate config={jolietConfig} />;
}